export const REVIEW_SECTION_CONTAINER_NAME = 'user-review-section'
